/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoDashboardMiningRequest model module.
 * @module model/WalletControllerDtoDashboardMiningRequest
 * @version 1.0
 */
class WalletControllerDtoDashboardMiningRequest {
    /**
     * Constructs a new <code>WalletControllerDtoDashboardMiningRequest</code>.
     * @alias module:model/WalletControllerDtoDashboardMiningRequest
     */
    constructor() { 
        
        WalletControllerDtoDashboardMiningRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoDashboardMiningRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoDashboardMiningRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoDashboardMiningRequest} The populated <code>WalletControllerDtoDashboardMiningRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoDashboardMiningRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoDashboardMiningRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoDashboardMiningRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} beginDate
 */
WalletControllerDtoDashboardMiningRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
WalletControllerDtoDashboardMiningRequest.prototype['endDate'] = undefined;






export default WalletControllerDtoDashboardMiningRequest;

